export const MAGIC_PUBLIC_KEY = process.env.NEXT_PUBLIC_MAGIC_PUBKEY!
export const OS_GROUP_ID = process.env.OS_GROUP_ID!
